/**
 * @file     xp.ts
 * @readme   ./README.md
 * @purpose  XP thresholds, level calculations, and progress math.
 */

import type { XPLevel, LessonProgress } from './types';

export const XP_LEVELS: XPLevel[] = [
  { level: 1, label: 'Newcomer', minXp: 0, maxXp: 100 },
  { level: 2, label: 'Explorer', minXp: 100, maxXp: 300 },
  { level: 3, label: 'Learner', minXp: 300, maxXp: 600 },
  { level: 4, label: 'Knowledgeable', minXp: 600, maxXp: 1000 },
  { level: 5, label: 'Expert', minXp: 1000, maxXp: 1500 },
  { level: 6, label: 'Specialist', minXp: 1500, maxXp: 2200 },
  { level: 7, label: 'Master', minXp: 2200, maxXp: 3000 },
  { level: 8, label: 'BC Real Estate Pro', minXp: 3000, maxXp: Infinity },
];

export function getLevelForXp(totalXp: number): XPLevel {
  for (let i = XP_LEVELS.length - 1; i >= 0; i--) {
    if (totalXp >= XP_LEVELS[i].minXp) return XP_LEVELS[i];
  }
  return XP_LEVELS[0];
}

export function getLevelProgress(totalXp: number): { current: number; required: number; percent: number } {
  const level = getLevelForXp(totalXp);
  if (level.maxXp === Infinity) return { current: totalXp - level.minXp, required: 0, percent: 100 };
  const current = totalXp - level.minXp;
  const required = level.maxXp - level.minXp;
  return { current, required, percent: Math.round((current / required) * 100) };
}

export function calculateTotalXp(progress: Record<string, LessonProgress>, xpMap: Record<string, number>): number {
  let total = 0;
  for (const [lessonId, p] of Object.entries(progress)) {
    if (p.status === 'completed' && xpMap[lessonId]) {
      total += xpMap[lessonId];
    }
  }
  return total;
}
